<template>
  <modal
      id="survey-modal"
      size="large"
      v-model="showModal"
      :title="from === 'user' ? generateModalTitle('user') : generateModalTitle('Survey')"
      @submit="submit"
      :loading="loading"
      :btn-label="selectedUrl ? $t('save') : $t('add')"
      :preloader="preloader">

    <form
        v-if="(isMailSettingExist || selectedUrl) && !preloader"
        ref="form"
        method="post"
        enctype="multipart/form-data"
        :data-url='selectedUrl ? selectedUrl : GET_STAFF_SURVEYS'
        @submit.prevent="submitData"
    >
      <div class="row">
        <div class="col-md-12">
          <app-form-group
              type="text"
              :disabled="this.$isAdmin()"
              :label="$t('title')"
              v-model="formData.title"
              :error-message="$errorMessage(errors, 'title')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <app-input
              type="text-editor"
              v-model="formData.description"
              v-if="!loading"
              :disabled="this.$isAdmin()"
              id="description"
              required
              :placeholder="$textAreaPlaceHolder('description')"
              row="5"
              :error-message="$errorMessage(errors, 'custom_content')"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-6">
          <app-form-group
              type="date"
              :label="$t('start_date')"
              :placeholder="$placeholder('start_date')"
              v-model="formData.start_date"
              :required="true"
              :error-message="$errorMessage(errors, 'start_date')"
          />
        </div>
        <div class="col-md-6">
          <app-form-group
              type="date"
              :label="$t('end_date')"
              :placeholder="$placeholder('end_date')"
              v-model="formData.end_date"
              :required="true"
              :error-message="$errorMessage(errors, 'end_date')"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <app-form-group-selectable
              type="select"
              :label="$t('status')"
              list-value-field="name"
              v-model="formData.status"
              :chooseLabel="$t('status')"
              :error-message="$errorMessage(errors, 'status')"
              :fetch-url="`${SELECTABLE_SURVEY_STATUS}`"
          />
        </div>
      </div>

    </form>

    <template v-if="!isMailSettingExist && !selectedUrl" slot="footer">
      <button type="button"
              class="btn btn-secondary"
              data-dismiss="modal">
        {{ $t('close') }}
      </button>
    </template>
  </modal>
</template>

<script>
import FormHelperMixins from "../../../../common/Mixin/Global/FormHelperMixins";
import ModalMixin from "../../../../common/Mixin/Global/ModalMixin";
import {
  GET_STAFF_SURVEYS,
  SELECTABLE_SURVEY_STATUS
} from "../../../Config/ApiUrl";
import {
  TENANT_MAIL_CHECK_URL,
} from "../../../../common/Config/apiUrl";
import {axiosGet, axiosPost, urlGenerator} from "../../../../common/Helper/AxiosHelper";
import LogMixin from "../../Mixins/LogMixin";
import {textEditorHints} from "../../../../common/Helper/Support/TextEditorHelper";
import TemplateMixins from "../../../../common/Components/Settings/Common/http/NotificationTemplate/TemplateMixins";
import {InputMixin} from "../../../../core/components/input/mixin/InputMixin";
import _ from "lodash";
import {kebabCase} from "../../../../common/Helper/Support/TextHelper";

export default {
  name: "SupportTicketCreateEditModal",
  mixins: [FormHelperMixins, ModalMixin, LogMixin, TemplateMixins, InputMixin],
  components: {
  },
  props: {
    from: {
      type: String,
      default: 'survey'
    },
    recommendation: {
      type: String,
      default: ''
    },
    loaderColor: {
      type: String,
      default: 'white-color'
    }
  },
  data() {
    return {
      textEditorHints,
      isModalActive: false,
      image: {
        product_image: null
      },
      isMailSettingExist: true,
      preloader: false,
      loading: false,
      formData: {
        title: "",
        description: "",
        start_date: "",
        end_date: "",
        category: "",
        status: "",
      },
      GET_STAFF_SURVEYS,
      SELECTABLE_SURVEY_STATUS,
    }
  },
  methods: {
    propsFor() {
      let props = this.$attrs;
      const cTor = this.$options.components['app-input']
      if (cTor) {
        let keys = Object.keys(cTor.options.props)
        return _.pick(props, keys.map(key => {
          return kebabCase(key)
        }))
      }
    },
    submit() {
      this.fieldStatus.isSubmit = true;
      this.loading = true;
      this.message = '';
      this.errors = {};

      this.isModalActive = false;
      // console.log(this.formData);
      this.submitData(this.formData);
    },
    afterSuccess({data}) {
      this.formData = {};
      $('#survey-modal').modal('hide');
      this.$emit('input', false);
      this.toastAndReload(data.message, this.from === 'ticket' ? 'survey-modal' : 'user-table');
      if (this.from === 'survey') {
        this.$hub.$emit(`reload-survey-table`)
      }
    },
    afterSuccessFromGetEditData({data}) {
      this.preloader = false;
      this.formData = data;
    },
    generateModalTitle(subject) {
      return this.$fieldTitle(this.selectedUrl ? 'edit' : 'add', subject, true);
    },
  },
  created() {
  },
  computed: {
    fileLabel() {
      if (this.value && this.fieldValue && this.fieldValue === this.value)
        return this.value?.name ? this.value.name : this.data.label;
      else return this.data.label;
    }
  },
  mounted() {
  },
  watch: {
  },
}
</script>
